var map = {
	"./1a_1280.png": 2716,
	"./1a_1920.png": 7521,
	"./1a_640.png": 9710,
	"./1b_1280.png": 2518,
	"./1b_1920.png": 6092,
	"./1b_640.png": 6716,
	"./2a_1280.png": 1578,
	"./2a_1920.png": 278,
	"./2a_640.png": 5817,
	"./2b_1280.png": 7871,
	"./2b_1920.png": 3415,
	"./2b_640.png": 5507,
	"./3a_1280.png": 5258,
	"./3a_1920.png": 9718,
	"./3a_640.png": 6623,
	"./3b_1280.png": 5485,
	"./3b_1920.png": 5508,
	"./3b_640.png": 5526,
	"./3c_1280.png": 3964,
	"./3c_1920.png": 1943,
	"./3c_640.png": 7435,
	"./3d_1280.png": 9317,
	"./3d_1920.png": 5602,
	"./3d_640.png": 4346,
	"./4a_1280.png": 1199,
	"./4a_1920.png": 9352,
	"./4a_640.png": 2282,
	"./4b_1280.png": 501,
	"./4b_1920.png": 4518,
	"./4b_640.png": 7580,
	"./4c_1280.png": 1599,
	"./4c_1920.png": 1749,
	"./4c_640.png": 2161,
	"assets/foldpavilion/1a_1280.png": 2716,
	"assets/foldpavilion/1a_1920.png": 7521,
	"assets/foldpavilion/1a_640.png": 9710,
	"assets/foldpavilion/1b_1280.png": 2518,
	"assets/foldpavilion/1b_1920.png": 6092,
	"assets/foldpavilion/1b_640.png": 6716,
	"assets/foldpavilion/2a_1280.png": 1578,
	"assets/foldpavilion/2a_1920.png": 278,
	"assets/foldpavilion/2a_640.png": 5817,
	"assets/foldpavilion/2b_1280.png": 7871,
	"assets/foldpavilion/2b_1920.png": 3415,
	"assets/foldpavilion/2b_640.png": 5507,
	"assets/foldpavilion/3a_1280.png": 5258,
	"assets/foldpavilion/3a_1920.png": 9718,
	"assets/foldpavilion/3a_640.png": 6623,
	"assets/foldpavilion/3b_1280.png": 5485,
	"assets/foldpavilion/3b_1920.png": 5508,
	"assets/foldpavilion/3b_640.png": 5526,
	"assets/foldpavilion/3c_1280.png": 3964,
	"assets/foldpavilion/3c_1920.png": 1943,
	"assets/foldpavilion/3c_640.png": 7435,
	"assets/foldpavilion/3d_1280.png": 9317,
	"assets/foldpavilion/3d_1920.png": 5602,
	"assets/foldpavilion/3d_640.png": 4346,
	"assets/foldpavilion/4a_1280.png": 1199,
	"assets/foldpavilion/4a_1920.png": 9352,
	"assets/foldpavilion/4a_640.png": 2282,
	"assets/foldpavilion/4b_1280.png": 501,
	"assets/foldpavilion/4b_1920.png": 4518,
	"assets/foldpavilion/4b_640.png": 7580,
	"assets/foldpavilion/4c_1280.png": 1599,
	"assets/foldpavilion/4c_1920.png": 1749,
	"assets/foldpavilion/4c_640.png": 2161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1114;